import React from 'react'
import strings from 'translations/ro.json'
const clients = strings.sections.clients

const Item2 = (props) => (
	<div className='item-container'>
		<h2 className='text'>{props.title}</h2>
		<p className='text'>{props.subtitle}</p>
	</div>
)

const Clients = () => (
	<section className='clients row' id='clients'>
		<div className='left-container content-container col-md-6 col-lg-6 order-2 order-xs-1 order-sm-1'>
			<h2 className='text'>{clients.title}</h2>
			<div className='items-container'>
				{clients.items.map((item, i) =>
					<Item2 key={i} {...item}/>
				)}
			</div>
		</div>
		<div className='right-container col-md-6 col-lg-6 order-1 order-xs-2 order-sm-2'>
			<img src={require('media/clients.jpg')} alt={clients.title}/>
		</div>
	</section>
)

export default Clients



// WEBPACK FOOTER //
// ./src/components/ui/sections/Clients.js